import React from 'react';

export const SyncStatusToast = ({ status }) => {
    const getIcon = (stepStatus) => {
        switch (stepStatus) {
            case 'running': return <span className="loader"></span>; // Změna zde!
            case 'success': return '✅';
            case 'error':   return '❌';
            case 'pending':
            default:        return '⚪';
        }
    };

    const getOverallStatus = () => {
        if (status.steps.some(s => s.status === 'error')) return { icon: '❌', text: 'Synchronization Failed!' };
        if (status.overall === 'done') return { icon: '✅', text: 'Synchronization Complete!' };
        return { icon: '⚙️', text: 'Synchronization in Progress...' };
    };
    
    const { icon: overallIcon, text: overallText } = getOverallStatus();

    return (
        <div className="sync-toast-content">
            <h4 className="toast-title">
                <span className="icon">{overallIcon}</span>
                {overallText}
            </h4>
            <ul>
                {status.steps.map((step, index) => (
                    <li key={index}>
                        <span className="icon">{getIcon(step.status)}</span>
                        <div className="text-content">
                            <span className="label">{step.label}</span>
                            {step.message && <span className="message">{step.message}</span>}
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};